import React, { Component } from 'react';

import Immutable, {Range} from 'immutable';
import { firebaseRoot, snapshotMap } from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route } from 'react-router';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import LinkTR from '../../components/LinkTR';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Col from 'react-bootstrap/lib/Col';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Static from 'react-bootstrap/lib/FormControls/Static';
import MathMarkup from '../../components/MathMarkup/MathMarkup';
import Lazy from 'lazy.js';
import ExerciseEditor from './ExerciseEditor';
import ExerciseReview from './ExerciseReview';
import Exercise from '../models/Exercise';


function StepsView({steps}) {
    if (!steps.numChildren()) {
        return <div>No steps defined yet.</div>;
    }

    return <table className="table table-hover">
        <thead>
        <tr>
            <th>Operation</th>
            <th>Logic</th>
            <th>Answer</th>
            <th>Hint</th>
        </tr>
        </thead>
        <tbody>
        {snapshotMap(steps, (step, i) => {
            const val = step.val();
            return <tr key={i}>
                <td>
                    <MathMarkup>{val.operation}</MathMarkup>
                </td>
                <td>{val.logic}</td>
                <td>
                    <MathMarkup>{val.answer}</MathMarkup>
                </td>
                <td>
                    <MathMarkup>{val.hint}</MathMarkup>
                </td>
            </tr>
        }) }
        </tbody>
    </table>;
}

const ExerciseView = React.createClass({
    mixins: [ReactFireMixin],

    getInitialState() {
        return {};
    },

    rebind(props) {
        const {params} = props;
        if (params.exerciseId) {
            this.bindAsObject(
                firebaseRoot.child('admin/base/exercises')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'exercise');
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/steps')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'steps');
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/review/exercise')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'baseReview');
        } else {
            this.unbind('exercise');
            this.unbind('steps');
        }
    },

    componentDidMount() {
        this.rebind(this.props);
    },

    componentWillReceiveProps(nextProps) {
        this.rebind(nextProps);
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }

        let markedStyle = 'rgba(255,115,0, 0.3)';
        let okStyle = 'rgba(0,128,0, 0.3)';
        let reviewStyle = okStyle;
        if (this.state.baseReview && this.state.baseReview.exists()) {
            reviewStyle = markedStyle;
        }

        const {exercise, steps} = this.state;
        const {params} = this.props;

        if (!exercise) {
            return <div />;
        }

        return <div>
            <ButtonToolbar>
                <TouchButton onClick={this.props.onEdit}>
                    <Glyphicon glyph="pencil"/>&nbsp;Edit
                </TouchButton>
                <TouchButton onClick={() => this.props.onClone(steps)}>
                    <Glyphicon glyph="duplicate"/>&nbsp;{this.props.isCloning ? 'Cancel cloning' : 'Clone...'}
                </TouchButton>
                <TouchButton onClick={this.props.onReview} style={{backgroundColor: reviewStyle}}>
                    <Glyphicon glyph="star"/>&nbsp;Review
                </TouchButton>
            </ButtonToolbar>
            <Static label="Text">
                <MathMarkup>{steps.child('text').val()}</MathMarkup>
            </Static>
            <StepsView steps={steps}/>
        </div>;
    }
});

const ExerciseList = React.createClass({
    mixins: [ReactFireMixin],

    getInitialState() {
        return {stepsToClone: null, isEditing: false, isReviewing: false};
    },

    rebind(props) {
        this.bindAsObject(firebaseRoot.child('admin/base/books')
            .child(props.params.bookId),
            'book');
        this.bindAsObject(firebaseRoot.child('admin/base/chapters')
            .child(props.params.bookId)
            .child(props.params.chapterId),
            'chapter');
        this.bindAsObject(
            firebaseRoot.child('admin/base/subchapters')
                .child(props.params.bookId)
                .child(props.params.chapterId)
                .child(props.params.subchapterId),
            'subchapter');
        this.bindAsDataSnapshot(
            firebaseRoot.child('admin/base/exercises')
                .child(props.params.bookId)
                .child(props.params.chapterId)
                .child(props.params.subchapterId),
            'exercises');
        this.bindAsTransform(
            firebaseRoot.child('admin/steps')
                .child(props.params.bookId)
                .child(props.params.chapterId)
                .child(props.params.subchapterId),
            'exerciseStepsByKey',
            dataSnapshot => Lazy(dataSnapshot).dataSnapshot().indexBy(e => e.key()).toObject());
    },

    componentWillMount() {
        this.rebind(this.props);
    },

    componentWillReceiveProps(nextProps) {
        this.rebind(nextProps);
    },

    firebaseDidCancel(error) {
        console.error(error);
    },

    onCloneStart(steps) {
        if (this.state.stepsToClone) {
            this.setState({stepsToClone: null});
        } else {
            this.setState({stepsToClone: steps});
        }
    },

    onReviewStart(steps) {
        this.setState({isReviewing: !this.state.isReviewing});
    },

    onCloneFinish(targetExercise) {
        const params = this.props.params;

        Exercise.saveSteps(params.bookId, params.chapterId, params.subchapterId, targetExercise.key(),
            this.state.stepsToClone.val()).then(
            () => this.setState({stepsToClone: null})
        );
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }

        const {book, chapter, subchapter, exerciseStepsByKey} = this.state;

        return (
            <div className="admin-content">
                <div className="admin-content-pane">
                    <div className="admin-pane-content">
                        <table className="table table-hover">
                            <tbody>
                            {Lazy(this.state.exercises).dataSnapshot().map(exercise => {
                                const steps = exerciseStepsByKey[exercise.key()];
                                return <LinkTR key={exercise.key()}
                                               to={`/admin/book/${book['.key']}/${chapter['.key']}/${subchapter['.key']}/${exercise.key()}`}
                                               activeStyle={{background: '#ddd'}}>
                                    <td>{exercise.child('name').val()}</td>
                                    <td>{steps && steps.numChildren()}</td>
                                    {this.state.stepsToClone &&
                                    this.state.stepsToClone.key() != exercise.key()
                                        ? <td><TouchButton onClick={this.onCloneFinish.bind(this, exercise)}><Glyphicon
                                        glyph="arrow-left"/>&nbsp;To here</TouchButton></td>
                                        : <td></td>}
                                </LinkTR>;
                            }).toArray()}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="admin-content-main">
                    <div className="admin-main-content">
                        <ol className="breadcrumb">
                            <li><TouchLink to={`/admin/book/${book['.key']}`}>{book.title}</TouchLink></li>
                            <li><TouchLink
                                to={`/admin/book/${book['.key']}/${chapter['.key']}`}>{chapter.name}</TouchLink></li>
                            <li className="active"><TouchLink
                                to={`/admin/book/${book['.key']}/${chapter['.key']}/${subchapter['.key']}`}>{subchapter.name}</TouchLink>
                            </li>
                        </ol>
                        {this.state.isEditing
                            ?
                            <ExerciseEditor book={book}
                                            params={this.props.params}
                                            onDone={() => { this.setState({isEditing: false})}}
                                            onClone={this.onCloneStart}
                                            onReview={this.onReviewStart}
                                            isCloning={!!this.state.stepsToClone}/>
                            :
                            null

                        }
                        {this.state.isReviewing
                            ?
                            <ExerciseReview book={book}
                                            params={this.props.params}
                                            onDone={() => { this.setState({isReviewing: false})}}
                                            onReview={this.onReviewStart}/>
                            :
                            null
                        }
                        {!this.state.isReviewing && !this.state.isEditing
                            ?
                            <ExerciseView book={book}
                                          params={this.props.params}
                                          onEdit={() => { this.setState({isEditing: true})}}
                                          onClone={this.onCloneStart}
                                          isCloning={!!this.state.stepsToClone}/>
                            :
                            null
                        }
                    </div>
                </div>
            </div>
        );
    }
});

export default ExerciseList;



/** WEBPACK FOOTER **
 ** ./src/admin/screens/ExerciseList.js
 **/